import { createStateContext } from '@change-corgi/core/react/context';

import type { ModalOptions } from '../../shared/types';

import { initialState } from './initialState';
import { mutations } from './mutations';
import type { MembershipModalState } from './types';

const {
	StateContext: MembershipModalStateContext,
	StateProvider: BaseMembershipModalStateContextProvider,
	useStateContext: useMembershipModalState,
} = createStateContext<MembershipModalState, typeof mutations, ModalOptions>({
	name: 'MembershipModalStateContext',
	mutations,
	initialState: (state) => initialState(state),
});

export { MembershipModalStateContext, BaseMembershipModalStateContextProvider, useMembershipModalState };
